// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCNjBnTn2UeR3FZaQ8DWsugLSWYGyuoYT0",
    authDomain: "meno-health.firebaseapp.com",
    databaseURL: "https://meno-health.firebaseio.com",
    projectId: "meno-health",
    storageBucket: "meno-health.appspot.com",
    messagingSenderId: "732792510946",
    appId: "1:732792510946:web:f66f92d9fb3c9d76"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
